import React from "react";
import { connect } from "react-redux";
import { Button, Popup } from "devextreme-react";
import {
  setShowHideForm,
  setCleanDataComplain,
  doDeleteDraft,
  openCloseModalBorrador,
  setStep,
  setCleanSolicitudAgenda,
  sendAgendamiento,
  abrirCerrarModalNuevaSolicitud,
  loadDataAgendaform,
  } from "../actions";
import SolicitudExamen from "./Formularios/SolicitudExamen";
import IngresoTrabajadores from "./Formularios/IngresoTrabajadores";
import ConfirmacionSolicitud from "./Formularios/ConfirmacionSolicitud";
import validaciones from "../../../../../../helpers/validaciones";
import LoadingOverlay from "../../../../../Shared/LoadingOverlay";
import { formatDateForFilter } from "../../../../../../helpers/dateFormat";
import moment from "moment"

class FormNuevaSolicitud extends React.Component {
  constructor(props) {
    super(props);
    this.autoSaveTimer = null;
  }

  getJsonData = () => {
    const Data = {};
    Data.Rut = validaciones.formatRut(this.props.jsonData.formInfoDenuncia.rutTxt, { showDots: false, showHyphen: true });
    Data.CompanyRut = this.props.companyId;
    Data.UserRut = this.props.userData.RUT;

    Data.jsonData = { ...this.props.jsonData };
    Data.jsonData.currentStep = this.props.activeStep;
    Data.jsonData.lastCompletedStep = this.props.lastCompletedStep;
    Data.jsonData = JSON.stringify(Data.jsonData);
    return Data;
  }

  startTimer = () => {
    if (!this.autoSaveTimer) { this.autoSaveTimer = setInterval(this.handleAutoSave, 1 * 60 * 1000); }
  }

  stoptimer = () => {
    if (this.autoSaveTimer) {
      clearInterval(this.autoSaveTimer);
      this.autoSaveTimer = null;
    }
  }

  ListComplains = () => {
    if (this.props.isModified) {
      this.props.dispatch(openCloseModalBorrador(true));
    } else {
      this.stoptimer();
      this.props.dispatch(setShowHideForm(false));
      this.props.dispatch(setCleanDataComplain());
    }
  }

  handleAutoSave = () => {
    const _updated = {
      isWorkersUpdate: this.props.isWorkersUpdate,
      isPoolsUpdate: this.props.isPoolsUpdate,
      isExamsUpdate: this.props.isExamsUpdate,
      isRequestHeaderUpdate: this.props.isRequestHeaderUpdate,
    };
    this.props.dispatch(sendAgendamiento(this.props.dataSolicitudAgendaSel, this.props.companyId, this.props.userData.RUT, 6, _updated, true, null, this.props.centroSeleccionado));
  }

  handleSave = () => {
    const _updated = {
      isWorkersUpdate: this.props.isWorkersUpdate,
      isPoolsUpdate: this.props.isPoolsUpdate,
      isExamsUpdate: this.props.isExamsUpdate,
      isRequestHeaderUpdate: this.props.isRequestHeaderUpdate,
    };
    const filters = {
      from: formatDateForFilter(moment().subtract(1, "year")),
      to: formatDateForFilter(moment()),
      companyRut: this.props.companyId,
      PetitionerRut: this.props.userData.RUT,
      StatusId: this.props.selectedTipoSolicitud.value.value,
    };
    this.stoptimer();
    this.props.dispatch(sendAgendamiento(this.props.dataSolicitudAgendaSel, this.props.companyId, this.props.userData.RUT, 6, _updated, null, filters, this.props.centroSeleccionado));
  }

  handleCerrar = (doDelete) => {
    this.props.dispatch(openCloseModalBorrador(false));
    this.stoptimer();
    const Id = this.props.dataSolicitudAgendaSel && this.props.dataSolicitudAgendaSel.idSolicitud ? this.props.dataSolicitudAgendaSel.idSolicitud : null;
    if (doDelete && Id && !this.props.editarBorrador) {
      this.props.dispatch(doDeleteDraft(Id));
    } else {
      this.props.dispatch(setCleanSolicitudAgenda());
      this.props.dispatch(setShowHideForm(false));
      this.props.dispatch(openCloseModalBorrador(false));
    }
    this.props.dispatch(setCleanDataComplain());

  }

  renderSteps(item, index) {
    const isStepCompleted = item.id <= this.props.lastCompletedStep;
    const isLastCompleted = item.id === this.props.lastCompletedStep;
    const isStepActive = item.id === this.props.activeStep;
    return (
      <div
        className="row zero"
        key={index}
        onClickCapture={() => {
          if (isStepCompleted && !isStepActive && item.id !== 1) {
            this.props.dispatch(setStep(item.id));
          }
        }}
        style={{
          userSelect: "none",
          marginTop: 3,
          cursor: isStepCompleted && item.id !== 1 ? "pointer" : "",
        }}
      >
        <div
          className="numberCircle"
          style={{
            background: isStepActive ? "#FFFF" : isStepCompleted ? "#9DC551" : "#00B2A9",
          }}
        >
          <div className="numberCircleText" style={{ color: isStepActive ? "#004A52" : "#FFFF" }}>
            {isStepCompleted && !isStepActive && !isLastCompleted ? <i className="material-icons">done</i> : item.id}
          </div>
        </div>
        <div className="contentTextStep col-10 zero-right">
          <div>
            <h4 style={{ color: "#FFFF" }}>
              {(index === 2 &&
                this.props &&
                this.props.jsonData &&
                this.props.jsonData.formInfoDenuncia &&
                this.props.jsonData.formInfoDenuncia.tipoDenuncia === "DIEP") ? item.text2 : item.text}
            </h4>
          </div>
          {isStepActive ? <p style={{ color: "white", marginBottom: 10 }}>{item.subtext}</p> : ""}
        </div>
      </div>
    );
  }

  renderCrearAgenda = () => (
    <div>
      <div className="col-12" style={{ justifyContent: "center" }}>
        <div style={{ width: "100%", textAlign: "center" }}>
          <p> ¿Quieres guardar la solicitud como borrador y terminar la gestión más tarde? </p>
        </div>

      </div>
      <div
        className="col-12"
        style={{
          position: "fixed", bottom: 10, width: "87%", textAlign: "center",
        }}
      >
        <Button
          text="Descartar borrador"
          className="delete-button-outline"
          type="normal"
          onClick={() => this.handleCerrar(true)}
          style={{ marginRight: 15 }}
        />
        <Button
          text="Guardar Borrador"
          type="success"
          disabled={!!this.props.isLoading}
          onClick={this.handleSave}

        />

      </div>
    </div>
  )

  handleNewSolicitud = () => {
    this.props.dispatch(abrirCerrarModalNuevaSolicitud(false));
    this.props.dispatch(setCleanSolicitudAgenda());
    this.props.dispatch(setStep(1));
    this.props.dispatch(setShowHideForm(true));
    this.props.dispatch(loadDataAgendaform(this.props.companyId));
  }

  render() {
    return (
      <div
        className="row zero formDenunicas"
        style={{
          position: "fixed",
          width: "100%",
          height: "100%",
          top: 0,
          left: this.props.showHideForm ? 0 : 2000,
          opacity: this.props.showHideForm ? 1 : 0,
          right: 0,
          bottom: 0,
          backgroundColor: "white",
          zIndex: 300,
          display: "flex",
          flexWrap: "nowrap",
        }}
      >
        {this.props.isLoading && <LoadingOverlay />}
        <div
          style={{
            paddingTop: 20, backgroundColor: "#004A52", minWidth: 290, maxWidth: 290,
          }}
        >
          <div className="tituloLogin col-12">
            <h2 style={{ color: "#fff" }}>Nueva solicitud</h2>
          </div>
          <div className="col-12">
            {this.props.steps.map((item, index) => this.renderSteps(item, index))}
          </div>
        </div>

        <div
          style={{
            overflowY: "auto", right: 0, height: "100%", width: "100%",
          }}
        >
          <div className="zero container-fluid">
            {this.props.showHideForm && (
              <div className="BtnCloseAlign">
                <Button
                  style={{
                    borderRadius: "50%",
                    background: "#EEEEEE",
                  }}
                  onClick={this.ListComplains}
                >
                  <i className="material-icons" style={{ fontSize: 20, color: "#8A8A8A", fontWeight: 700 }} > clear </i>
                </Button>
              </div>
            )}
            <div
              className="row zero"
              style={{
                marginLeft: 45, marginBottom: 60, paddingRight: 70, marginTop: 30,
              }}
            >
              <div className="col-lg-12">
                {this.props.activeStep === 1 && <SolicitudExamen onSave={this.startTimer} />}
                {this.props.activeStep === 2 && <IngresoTrabajadores onSave={this.startTimer} />}
                {this.props.activeStep === 3 && <ConfirmacionSolicitud onSend={this.stoptimer} />}
                <Popup
                  visible={this.props.isOpenModalBorrador}
                  showCloseButton={false}
                  dragEnabled={false}
                  maxHeight="270px"
                  onHiding={() => this.handleCerrar(true)}
                  maxWidth="500px"
                  title="Cerrar solicitud"
                  showTitle
                  contentRender={() => (this.renderCrearAgenda())}
                />
                <Popup
                  showCloseButton
                  visible={this.props.openModalButtonNuevaSolicitud}
                  dragEnabled={false}
                  maxHeight="200px"
                  onHiding={() => this.props.dispatch(abrirCerrarModalNuevaSolicitud(false))}
                  maxWidth="600px"
                  title="Solicitudes"
                  // className=""
                  contentRender={() => (<div style={{ height: "100%", display: "grid" }}>
                    <div className="col-12" style={{ justifyContent: "center" }}>
                      <div style={{ width: "100%", textAlign: "center" }}>
                        Recuerda que toda la información es responsabilidad de quien la emite
                      </div>
                    </div>

                    <div style={{ margin: "auto" }}>
                      <Button
                        type="success"
                        className="next-button"
                        text="Aceptar"
                        onClick={this.handleNewSolicitud}
                      />
                    </div>
                  </div>)}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  selectedTipoSolicitud: state.solicitudesAgendaSel.selectedTipoSolicitud,
  lastCompletedStep: state.solicitudesAgendaSel.lastCompletedStep,
  isLoading: state.solicitudesAgendaSel.isLoading,
  steps: state.solicitudesAgendaSel.steps,
  activeStep: state.solicitudesAgendaSel.activeStep,
  showHideForm: state.solicitudesAgendaSel.showHideForm,
  isOpenModalBorrador: state.solicitudesAgendaSel.isOpenModalBorrador,
  editingDraft: state.solicitudesAgendaSel.editingDraft,
  isModified: state.solicitudesAgendaSel.isModified,
  companyId: state.global.companyId,
  userData: state.global.userData,
  jsonData: state.solicitudesAgendaSel.jsonData,
  dataSolicitudAgendaSel: state.solicitudesAgendaSel.dataSolicitudAgendaSel,
  isPoolsUpdate: state.solicitudesAgendaSel.isPoolsUpdate,
  isExamsUpdate: state.solicitudesAgendaSel.isExamsUpdate,
  isWorkersUpdate: state.solicitudesAgendaSel.isWorkersUpdate,
  openModalButtonNuevaSolicitud: state.solicitudesAgendaSel.openModalButtonNuevaSolicitud,
  isRequestHeaderUpdate: state.solicitudesAgendaSel.isRequestHeaderUpdate,
  editarBorrador: state.solicitudesAgendaSel.editarBorrador,
  centroSeleccionado: state.solicitudesAgendaSel.centroSeleccionado,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(FormNuevaSolicitud);
